import React from 'react'
//Local Modules
import Tooltip from '@material-ui/core/Tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { useStyles } from './styles'

const SimpleCheckbox = ({ label, tooltipText, error, value, onValueChange, ...props }) => {
    const classes = useStyles()
    return (
        <div className={classes.formCtrl}>
            <div className={classes.checkbox}>
                <input
                    checked={value}
                    className={classes.input}
                    onChange={e => onValueChange(e.target.checked)}
                    type="checkbox"
                    {...props}
                />
                <div className={classes.labelContainer}>
                    <label className={classes.label} htmlFor={props.id || props.name}>
                        {label}
                    </label>
                </div>
                {tooltipText && (
                    <Tooltip title={tooltipText} placement="left">
                        <div>
                            <FontAwesomeIcon className={classes.info} icon={faInfoCircle} />
                        </div>
                    </Tooltip>
                )}
            </div>
            {error ? <div className={classes.error}>{error}</div> : null}
        </div>
    )
}

export default React.memo(SimpleCheckbox)
